import {memo} from 'react';

import styled from 'styled-components';

import {getLocalizationService} from '~/shared/services/localisationService';
import {attachModal} from '~/shared/components/ReduxModal';
import {body14Normal, body16Bold} from '~/shared/theme/typography';

import CreditImg from './assets/account-credit.svg?react';

const Root = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  min-width: 328px;
  min-height: 245px;
  background-color: ${({theme}) => theme.colors.surface};
`;

const CreditImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledCreditImg = styled(CreditImg)`
  margin-top: 32px;
`;

const Title = styled.span`
  ${body16Bold}
  line-height: 24px;
  color: ${({theme}) => theme.colors.text2};
  margin-top: 24px;
  text-align: center;
`;

const SubTitle = styled.span`
  ${body14Normal}
  text-align: center;
  color: ${({theme}) => theme.colors.text2};
  line-height: 20px;
  margin-top: 8px;
  max-width: 224px;
`;

const AutoCreditInfoModal = () => {
  const {t} = getLocalizationService();

  return (
    <Root>
      <CreditImageWrapper>
        <StyledCreditImg className="avoid-fill-stroke"/>
      </CreditImageWrapper>
      <Title id="modal-title">{t('add_credit_automatically')}</Title>
      <SubTitle>{t('add_credit_automatically_description')}</SubTitle>
    </Root>
  );
};

export default attachModal('auto_credit_info_modal', memo(AutoCreditInfoModal));
